import EzloActions from 'actions/EzloActions';
import { MeshBotAction } from 'actions';
import { isCloudMeshBotType } from 'containers/Ezlo/EzloMeshbot/utils';

/**
 * Returns the appropriate thunk for updating MeshBot enabled status based on the MeshBot type:
 * local (has controller serial) or cloud.
 *
 * @param {Object} params - MeshBot table row data
 * @param {boolean} isMeshBotActive - new enabled status
 * @returns {Function|undefined} thunk to dispatch, or undefined if the MeshBot type is not supported
 * @example
 * const updateMeshBotStatus = getUpdateMeshBotStatusThunk({ serial: '92001952', id: '666c1630...' }, false);
 * dispatch(updateMeshBotStatus);
 */
export const getUpdateMeshBotStatusThunk = (params, isMeshBotActive) => {
    const { serial, id, type } = params || {};
    if (serial) {
        return EzloActions.updateLocalMeshBotStatus(serial, id, isMeshBotActive);
    }

    if (isCloudMeshBotType(type)) {
        return MeshBotAction.updateCloudMeshbotStatus(params, isMeshBotActive);
    }
};
